/**
 * 判断是否数字
 * @return {Boolean} 是否数字
 */
var isType = require('./is-type');

var isNumber = function isNumber(value) {
  return isType(value, 'Number');
};

module.exports = isNumber;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/lib/type/is-number.js
// module id = 12
// module chunks = 0